import { store } from "../redux/store";
import { clearAuth } from "../redux/reducers/authSlice";
import { REDUX_PERSIST_KEY } from "../config";

const clearStoredSession = () => {
  sessionStorage.removeItem("_t");
  sessionStorage.removeItem("_rt");
  sessionStorage.removeItem("_e");
  localStorage.removeItem("_t");
  localStorage.removeItem("_rt");
  localStorage.removeItem("_e");
  localStorage.removeItem(`persist:${REDUX_PERSIST_KEY}`);
};

export const handleSessionExpired = () => {
  clearStoredSession();
  store.dispatch(clearAuth());
  window.location.replace("/login");
};
